import React from "react";
import {useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
import {IDV, CLAMP, FONT_STACK} from "../../../presets/idv";

export const CTAScene: React.FC<{
  profile: string;
  objective: "seguir" | "engajar" | "vender";
}> = ({profile, objective}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();

  const badgeProgress = spring({
    frame,
    fps,
    config: {damping: 14, stiffness: 100, mass: 0.8},
  });

  const mainProgress = spring({
    frame: frame - 30,
    fps,
    config: {damping: 12, stiffness: 120, mass: 0.8},
  });

  const profileProgress = spring({
    frame: frame - 60,
    fps,
    config: {damping: 10, stiffness: 140, mass: 0.6},
  });

  const btnProgress = spring({
    frame: frame - 90,
    fps,
    config: {damping: 8, stiffness: 200, mass: 0.8},
  });

  const pulse = frame > 120 ? 1 + Math.sin((frame - 120) * 0.08) * 0.02 : 1;
  const glowIntensity =
    frame > 120 ? 0.3 + Math.sin((frame - 120) * 0.06) * 0.15 : 0;

  const ctaText =
    objective === "seguir"
      ? "Segue pra nao errar as proximas"
      : objective === "engajar"
        ? "Comenta quantas voce acertou"
        : "Link na bio";

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "#000000",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
        padding: "0 60px",
      }}
    >
      <div
        style={{
          opacity: badgeProgress,
          transform: `translateY(${interpolate(badgeProgress, [0, 1], [20, 0], CLAMP)}px)`,
          fontSize: 14,
          fontWeight: 600,
          color: IDV.gray,
          letterSpacing: 1.5,
          textTransform: "uppercase",
          fontFamily: FONT_STACK,
        }}
      >
        Acertou quantas?
      </div>

      <div
        style={{
          opacity: mainProgress,
          transform: `translateY(${interpolate(mainProgress, [0, 1], [15, 0], CLAMP)}px) scale(${interpolate(mainProgress, [0, 1], [0.9, 1], CLAMP)})`,
          fontSize: 28,
          fontWeight: 700,
          color: IDV.white,
          fontFamily: FONT_STACK,
          textAlign: "center",
          lineHeight: 1.3,
          maxWidth: "85%",
        }}
      >
        {ctaText}
      </div>

      <div
        style={{
          opacity: profileProgress,
          transform: `translateY(${interpolate(profileProgress, [0, 1], [15, 0], CLAMP)}px)`,
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginTop: 8,
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            borderRadius: 999,
            background: `linear-gradient(135deg, ${IDV.secondary}, ${IDV.third})`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            fontWeight: 800,
            color: "#000",
            fontFamily: FONT_STACK,
          }}
        >
          GR
        </div>
        <div>
          <div
            style={{
              fontSize: 18,
              fontWeight: 700,
              color: IDV.white,
              fontFamily: FONT_STACK,
            }}
          >
            {profile}
          </div>
          <div
            style={{
              fontSize: 12,
              color: IDV.gray,
              fontFamily: FONT_STACK,
            }}
          >
            Crescimento previsivel
          </div>
        </div>
      </div>

      <div
        style={{
          opacity: btnProgress,
          transform: `translateY(${interpolate(btnProgress, [0, 1], [30, 0], CLAMP)}px) scale(${interpolate(btnProgress, [0, 1], [0.5, 1], CLAMP) * pulse})`,
          marginTop: 16,
          padding: "16px 48px",
          borderRadius: 999,
          background: IDV.secondary,
          fontSize: 18,
          fontWeight: 700,
          color: "#000",
          fontFamily: FONT_STACK,
          letterSpacing: 0.5,
          boxShadow: `0 0 30px rgba(0,223,130,${glowIntensity}), 0 0 60px rgba(0,223,130,${glowIntensity * 0.5})`,
        }}
      >
        SEGUIR
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
